import React from 'react';
import { FileUpload, PreviewFile } from '../../components/files/FilesUpload';
import { useAppContext } from '../../contexts/AppContext';
import { Image } from 'lucide-react';

interface MessageFormImageProps {
    value: string[];
    setValue: (value: string[]) => void;
    disabled?: boolean;
    onUploadingChange?: (loading: boolean) => void;
}

export default function MessageFormImage({
    value,
    setValue,
    disabled = false,
    onUploadingChange,
}: MessageFormImageProps) {
    const { errorSnackbar } = useAppContext();

    return (
        <FileUpload
            value={value}
            setValue={setValue}
            disabled={disabled}
            onLoadingChange={onUploadingChange}
        >
            {({ fileData, handleChange, removeFile, inputRef, loading }: any) => {
                const maxFiles = 1;

                const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                    const selectedFiles = Array.from(e.target.files || []);
                    const availableSlots = maxFiles - fileData.length;

                    if (availableSlots <= 0) {
                        errorSnackbar(`Você já atingiu o limite de ${maxFiles} arquivos.`);
                        return;
                    }

                    const filesToUpload = selectedFiles.slice(0, availableSlots);

                    handleChange(filesToUpload);
                };

                return (
                    <div className="px-4 py-2.5">
                        {fileData.length < maxFiles && (
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={inputRef}
                                    disabled={loading}
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                                <button
                                    type="button"
                                    className="estab-link-button"
                                    disabled={loading || disabled}
                                    onClick={() => inputRef.current?.click()}
                                >
                                    <Image aria-hidden />
                                    Adicionar imagem
                                </button>
                            </>
                        )}
                        <div className="flow-root">
                            {fileData.map((file: any) => (
                                <PreviewFile key={file.id} fileData={file} onRemove={removeFile} />
                            ))}
                        </div>
                    </div>
                );
            }}
        </FileUpload>
    );
}
